import { ForgeRelation, ForgeRelationType } from "@supernova-studio/model";
import z from "zod";
export const DTOForgeRelationType = ForgeRelationType;
export const DTOForgeRelation = ForgeRelation;
export const DTOForgeRelationCreate = DTOForgeRelation.omit({
    id: true,
    createdAt: true,
});
export const DTOForgeRelationDelete = z.object({
    sourceItemId: z.string().uuid(),
    targetItemId: z.string().uuid(),
});
export const DTOForgeRelationListInput = z.object({
    projectId: z.string(),
});
export const DTOForgeRelationListResponse = z.object({
    relations: z.array(DTOForgeRelation),
});
export const DTOForgeEntity = z.object({
    id: z.string().uuid(),
    type: DTOForgeRelationType,
});
